import React from "react";

import "dotenv/config";
import { BrowserRouter } from "react-router-dom";

import { AppContextProvider } from "contexts/AppContext";
import useVH from "hooks/useVh";

import "styles/App.css";
import AppRoutes from "./AppRoutes";

const App = () => {
	useVH();
	return (
		<BrowserRouter>
			<AppContextProvider>
				<AppRoutes />
			</AppContextProvider>
		</BrowserRouter>
	);
};

export default App;
